import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import Application from './application/container/ApplicationContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';

function OccupationalPermitContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Occupational Permit</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW OCCUPATIONAL PERMIT DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/occupational-permit"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW OCCUPATIONAL PERMIT TRANSACTIONS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/occupational-permit/application"
          >
            Applications
          </NavLink>
        )}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route path={`${match.path}/application`} component={Application} />
      </Switch>
    </div>
  );
}

OccupationalPermitContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(OccupationalPermitContainer);
